import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Grid2 from '@mui/material/Unstable_Grid2';

const FilterBar = ({ filters, onFilterChange }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  const classifications = [
    { value: '', label: 'All Classifications' },
    { value: 'HIGH_RISK', label: 'High Risk' },
    { value: 'MEDIUM_RISK', label: 'Medium Risk' },
    { value: 'LOW_RISK', label: 'Low Risk' },
    { value: 'NO_THREAT', label: 'No Threat' }
  ];

  const suspicionScoreOptions = [
    { value: '', label: 'Any Score' },
    { value: 90, label: '90+ (Critical)' },
    { value: 70, label: '70+ (High)' },
    { value: 50, label: '50+ (Medium)' },
    { value: 30, label: '30+ (Low)' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const applyFilters = () => {
    const filterParams = {};

    if (localFilters.classification) {
      filterParams.classification = localFilters.classification;
    }

    if (localFilters.minSuspicionScore) {
      filterParams.minSuspicionScore = localFilters.minSuspicionScore;
    }

    filterParams.limit = localFilters.limit || 50;
    filterParams.skip = 0;

    onFilterChange(filterParams);
  };

  const resetFilters = () => {
    const defaultFilters = {
      classification: null,
      minSuspicionScore: null,
      limit: 50,
      skip: 0
    };
    setLocalFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Grid2 container spacing={2} alignItems="flex-end">
          {/* Classification Filter */}
          <Grid2 xs={12} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Classification</InputLabel>
              <Select
                label="Classification"
                value={localFilters.classification || ''}
                onChange={(e) =>
                  handleFilterChange(
                    'classification',
                    e.target.value || null
                  )
                }
              >
                {classifications.map((cls) => (
                  <MenuItem
                    key={cls.value || 'all'}
                    value={cls.value}
                  >
                    {cls.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Min Suspicion Score Filter */}
          <Grid2 xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Min Suspicion Score</InputLabel>
              <Select
                label="Min Suspicion Score"
                value={localFilters.minSuspicionScore || ''}
                onChange={(e) =>
                  handleFilterChange(
                    'minSuspicionScore',
                    e.target.value ? parseInt(e.target.value) : null
                  )
                }
              >
                {suspicionScoreOptions.map((score) => (
                  <MenuItem
                    key={score.value || 'any'}
                    value={score.value}
                  >
                    {score.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>

          {/* Results Per Page */}
          <Grid2 xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Per Page</InputLabel>
              <Select
                label="Per Page"
                value={localFilters.limit || 50}
                onChange={(e) =>
                  handleFilterChange('limit', parseInt(e.target.value))
                }
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </Grid2>

          {/* Action Buttons */}
          <Grid2 xs={12} md={3}>
            <ButtonGroup size="small" fullWidth>
              <Button variant="contained" onClick={applyFilters}>
                Apply
              </Button>
              <Button
                variant="outlined"
                onClick={resetFilters}
                title="Reset Filters"
              >
                Reset
              </Button>
            </ButtonGroup>
          </Grid2>
        </Grid2>

        {/* Info Row */}
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Use filters to narrow down suspicious activity results and identify
            specific threat patterns
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterBar;
